export {default} from './Tabs';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Tabs/index.js